module.exports = __webpack_public_path__ + "static/media/unlock.24f5650a.svg";